import './home.scss';
import template from './home.html';
import { LoginActions } from 'core/services/login';
import { NavigationActions } from 'core/services/navigation';
import commonI18N from 'i18n/common/es.json';
import configFile from 'config.json';
import { rest } from 'core/api';
import { logout } from 'core/util';

// MODULE EXPORTS
export let HomeComponent = {
  templateUrl: template,
  selector: 'home',
  bindings: {
    translations: '='
  },
  controller: HomeCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(commonI18N);

let actions = Object.assign({}, LoginActions);
actions = Object.assign(actions, NavigationActions);

HomeCtrl.$inject = ['$ngRedux','localStorageService', '$state', '$window'];

function HomeCtrl($ngRedux, localStorageService, $state, $window) {
  Object.assign(this, { $ngRedux, $state });
  this.versionFrontend = configFile.version;
  this.mapStateToThis = mapStateToThis.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, actions)(this);
  this.$onDestroy = unsubscribe;
  
  let self = this;
  $ngRedux.dispatch(rest.actions.buildInfo({}, {}, (err, data) => {
    if (!err && data) {
      self.versionBackend = data;
    } else if (err) {
      console.log('Error obteniendo version del backend.');
    }
  }));


  this.scrollMenu = function() {
    $('#page-sidebar')[0].scrollTo(0, 0);
  };

  function mapStateToThis(state) {
    let sessionInitDate = localStorageService.get('sessionInitDate');
    let today = new Date();
    if (sessionInitDate !== today.getDate()) {
      logout(localStorageService, $window);
    }
    return {
      login: state.login,
      navigation: state.navigation
    };
  }
}


// WEBPACK FOOTER //
// ./src/components/home/home.component.js